import { generateCrud } from './helpers'

export default function (itemType, id) {
  const path = `/api/${itemType}s/${id}/position`
  const crud = generateCrud(path)

  return {
    update: crud.update
  }
}
